import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Board } from 'src/app/core/models/board.model';
import { BoardRead } from 'src/app/core/models/boardRead.model';
import { BoardStats } from 'src/app/core/models/boardStats.model';
import { SalesRep } from 'src/app/core/models/sales-rep.model';
import { BoardService } from 'src/app/core/services/board.service';
import { boardReadService } from 'src/app/core/services/boardRead.service';
import { BoardStatService, GroupedStats } from 'src/app/core/services/boardstats.service';
import { LocationService } from 'src/app/core/services/location.service';
import { SalesRepService } from 'src/app/core/services/sales-rep.service';
import { ChangeDetectorRef } from '@angular/core';
import { BoardStatsByIdComponent } from 'src/app/pages/boardStatsById/boardStatsById.component';
import { LoginService } from 'src/app/core/services/login.service';
import { UserType } from 'src/app/core/models/userType.models';


@Component({
  selector: 'app-board-stats-dashboard',
  templateUrl: './boardStatsDashBoard.component.html',
  styleUrls: ['./boardStatsDashBoard.component.scss'],
  providers: [DatePipe]
})

/**
 * Dashboard Component
 */
export class BoardStatsDashboardComponent implements OnInit {
  term: string = '';
  boardStats: BoardStats[];
  filteredStats:BoardStats[];
  filteredSalesReps: Map<string, SalesRep> = new Map();
  filteredSalesRepsArray: SalesRep[] = [];
  selectedSalesRep: any = null;
  filteredBoards: Board[]
  showCard = {
    cashInPerDay: true,
    netPerDay: true,
    gameStats: true,
    detailedGameStats: true
  };
  board: Board[];
  sortColumn: string = '';
  sortDirection: boolean = true;
  latestBoardStats = []
  statsEndDate: NgbDateStruct;
  statsStartDate: NgbDateStruct;
  averageCashInPerDayPerFilteredBoard = 0;
  averageNetPerDayPerFilteredBoard = 0
  showStats = false
  showGameStats = false
  boardStatsByGame: Map<string, GroupedStats>;


  constructor(private boardService: BoardService, private boardStatsService: BoardStatService, private modalService: NgbModal, private datePipe: DatePipe, 
    private locationService: LocationService, private salesRepService: SalesRepService, private cdr: ChangeDetectorRef, private loginService: LoginService) {
    const today = new Date();
    this.statsEndDate = { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    this.statsStartDate = { year: oneMonthAgo.getFullYear(), month: oneMonthAgo.getMonth() + 1, day: oneMonthAgo.getDate() };
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Board Stats', active: true }];
    await this.refresh();
  }

  

  async refresh() {
    if (this.loginService.userType === UserType.EXTERNAL || this.loginService.userType === UserType.TECH ){
        this.showCard.cashInPerDay = false;
        this.showCard.detailedGameStats = false;
        this.showCard.gameStats = false;
        this.showCard.netPerDay = false
    } else {
      this.showCard.cashInPerDay = true;
      this.showCard.detailedGameStats = true;
      this.showCard.netPerDay = true;
      this.showCard.gameStats = true;
    }

    // Fetch all the locations where enabled is 0 (disabled locations)
    const allLocations = await this.locationService.getAll();
    const startDate = new Date(this.statsStartDate.year, this.statsStartDate.month - 1, this.statsStartDate.day);
    const endDate = new Date(this.statsEndDate.year, this.statsEndDate.month - 1, this.statsEndDate.day, 23, 59, 59);

    console.log('Fetching data between:', startDate, endDate);
    
    // Get the IDs of the locations where enabled = 0
    const disabledLocationIds = allLocations
      .filter(location => location.enabled === true)  // Filter locations that are not enabled
      .map(location => location.locationTag);  // Extract the location IDs
  
    // Fetch all board stats
    const allBoardStats = await this.boardStatsService.getAllByDateRange(startDate, endDate);
  
    // Filter the boardStats to include only those where the associated location is in the disabledLocationIds
    this.boardStats = allBoardStats.filter(item => 
      disabledLocationIds.includes(item.board?.location.locationTag) &&  // Check if board's locationId is disabled
      item.daysSincePrevRead > 0 && 
      item.cashInDiff > 0 && 
      item.cashOutDiff > 0 && 
      item.board?.location?.salesRep?.firstName !== 'Warehouse'
    );

    this.boardStatsByGame = this.boardStatsService.groupStatsByBoardDetails(this.boardStats, this.boardStatsService.standardGameKeyFunction);
  
    // Update filtered stats
    this.updateFilteredStats();
  
    // Log the filtered boardStats for debugging
    console.log('refresh', { allBoardStats, "boardStats": this.boardStats, 'boardStatsByGame': this.boardStatsByGame });
  }

  onDateChange() {
    console.log('Date changed:', this.statsStartDate, this.statsEndDate);
    this.refresh(); // Automatically refresh data when dates change
  } 

  get gameList(): string[] {
    return Array.from(this.boardStatsByGame.keys());
  }
  
  onSalesRepFilterChange(): void {
    if (this.selectedSalesRep) {
      const { firstName, lastName } = this.selectedSalesRep;
      this.filteredStats = this.boardStats.filter((item) => {
        const salesRep = item?.board?.location?.salesRep;
        return (

          salesRep?.firstName === firstName &&
          salesRep?.lastName === lastName
        );
      });
    } else {
      // If no sales rep is selected, reset to show all stats
      this.filteredStats = [...this.boardStats];
    }
  
    // Now, recalculate the averages after filtering
    this.boardStatsByGame = this.boardStatsService.groupStatsByBoardDetails(this.filteredStats, this.boardStatsService.standardGameKeyFunction);
    this.calculateAverages();
    this.onSearch();
    
    console.log('Filtered Stats:', this.filteredStats);
  }

  getBoardtStatsLink(item: BoardStats): String {
    return "";
  }

  getValueByColumn(item, column: string) {
    // Access nested properties dynamically based on column
    switch (column) {
      case 'timeStamp': return new Date(item.timeStamp).toISOString();
      case 'salesRep': return `${item.board?.location?.salesRep.firstName} ${item.board?.location?.salesRep.lastName}`;
      case 'fusionConnect': return item.board?.fusionConnect;
      case 'gameName': return item.board?.installedGamePackage?.name;
      case 'cashIn': return item.cashInDiff;
      case 'cashOut': return item.cashOutDiff;
      case 'coinIn': return item.coinInDiff;
      case 'coinOut': return item.coinOutDiff;
      case 'gamesPlayed': return item.gamePlayedDiff;
      case 'gamesWon': return item.gameWonDiff;
      case 'assetTag': return item.assetTag;
      case 'cashIn/day': return item.cashInDiff / item.daysSincePrevRead;
      case 'netRevenue': return item.cashInDiff - item.cashOutDiff;
      case 'netRevenue/day': return item.profit / item.daysSincePrevRead;
      case 'serialNumber': return item.serialNumber;
      case 'payoutPercentage': return item.holdPercentage;
      case 'daysSincePrevRead': return item.daysSincePrevRead;
      // Add other cases as necessary
      default: return item[column];
    }
  }

  onSearch() {
    const termLower = this.term.toLowerCase().trim();
  
    console.log('Search Term:', termLower); // Log to check the search term
  
    // Combine both filters: SalesRep and game name
    this.filteredStats = this.boardStats.filter((boardStats) => {
      const salesRep = boardStats.board?.location?.salesRep;
      const gameName = boardStats.board?.installedGamePackage?.name?.toLowerCase();
  
      // Check if the game name matches the search term
      const matchesTerm =
        !termLower ||
        gameName.includes(termLower) || // Normal matching
        (termLower === 'classic' && gameName.includes('klassic')) || // Special case for 'classic'
        (termLower === 'klassic' && gameName.includes('classic'));  // Special case for 'klassic'
  
      // Check if the SalesRep matches the selected one
      const matchesSalesRep =
        !this.selectedSalesRep ||
        (salesRep?.firstName === this.selectedSalesRep.firstName &&
          salesRep?.lastName === this.selectedSalesRep.lastName);
  
      return matchesTerm && matchesSalesRep; // Both conditions must be true
    });
  }
  
  
  
  updateFilteredStats(filter: any = null) {
    console.log((this.datePipe.transform(this.boardStats[0]?.timeStamp)?.toLowerCase()), {
      filter, stats: this.boardStats,
      match: (this.datePipe.transform(this.boardStats[0]?.timeStamp)?.toLowerCase()?.includes(filter))
    })
    if(filter){
      this.filteredStats = this.boardStats.filter(boardStats =>
        (this.datePipe.transform(boardStats.timeStamp)?.toLowerCase().includes(filter)) ||
        (boardStats.board.serialNumber.toLowerCase().includes(filter)) ||
        (boardStats.board.assetTag.toLowerCase().includes(filter)) ||
        (boardStats.board.location.salesRep.firstName.toLowerCase().includes(filter)) ||
        (boardStats.board.location.salesRep.lastName.toLowerCase().includes(filter)) ||
        (boardStats.board.installedGamePackage.name.toLowerCase().includes(filter)) ||
        (boardStats.board.installedGamePackage.version.toLowerCase().includes(filter))
      );
      console.log('Filtered Stats:', this.filteredStats);  // Log to check filtered results
    } else {
      this.filteredStats =  this.boardStats;
    }
    this.averageCashInPerDayPerFilteredBoard = 0;
    this.averageNetPerDayPerFilteredBoard = 0;
    for(let s of this.filteredStats) {
      this.averageCashInPerDayPerFilteredBoard += (s.cashInDiff / s.daysSincePrevRead) 
      this.averageNetPerDayPerFilteredBoard    += (s.profit / s.daysSincePrevRead)
    } 
    this.averageCashInPerDayPerFilteredBoard /= this.filteredStats.length
    this.averageNetPerDayPerFilteredBoard    /= this.filteredStats.length

    this.filteredSalesReps = this.filteredStats.reduce((map, stat) => {
      const sr = stat?.board?.location?.salesRep;
      if (sr) map.set(sr.id, sr);
      return map;
    }, new Map());

    this.filteredSalesRepsArray = Array.from(this.filteredSalesReps.values());  
    
    this.cdr.detectChanges();
    console.log("average cash in per day per board", this.averageCashInPerDayPerFilteredBoard)
    console.log("average net per day per board", this.averageNetPerDayPerFilteredBoard)
  }

  calculateAverages() {
    this.averageCashInPerDayPerFilteredBoard = 0;
    this.averageNetPerDayPerFilteredBoard = 0;
  
    if (this.filteredStats.length > 0) {
      for (let s of this.filteredStats) {
        this.averageCashInPerDayPerFilteredBoard += (s.cashInDiff / s.daysSincePrevRead);
        this.averageNetPerDayPerFilteredBoard += (s.profit / s.daysSincePrevRead);
      }
      this.averageCashInPerDayPerFilteredBoard /= this.filteredStats.length;
      this.averageNetPerDayPerFilteredBoard /= this.filteredStats.length;
    } else {
      // Handle the case where no stats are filtered
      this.averageCashInPerDayPerFilteredBoard = 0;
      this.averageNetPerDayPerFilteredBoard = 0;
    }
  }
  
  

    sortData(column: string) {
      if (this.sortColumn === column) {
        this.sortDirection = !this.sortDirection;
      } else {
        this.sortColumn = column;
        this.sortDirection = true;
      }
    
      this.boardStats.sort((a, b) => {
        const valA = this.getValueByColumn(a, column);
        const valB = this.getValueByColumn(b, column);
    
        if (valA < valB) return this.sortDirection ? -1 : 1;
        if (valA > valB) return this.sortDirection ? 1 : -1;
        return 0;
      });
    }

    openBoardStatsModal(assetTag: string): void {
      const modalRef = this.modalService.open(BoardStatsByIdComponent, {
        size: 'lg', // or 'sm' depending on your design
      });
  
      modalRef.componentInstance.assetTag = assetTag;  // Pass the assetTag to the modal component
    }
  }
